import { render } from "./NavbarDropdown.vue?vue&type=template&id=491973dc&scoped=true"
import script from "./NavbarDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarDropdown.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-491973dc"

export default script